// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"a7ea444a","255":"4d818bc3"}[chunkId] + ".chunk.css";
};